// extracted by mini-css-extract-plugin
export default {"page":"pZ-z","cartModal":"qZ-z","checkout":"rZ-z","placeholder":"sZ-z","account":"tZ-z"};